<template>
  <div style="display: initial" @click="showForbiddenDialog">
    <slot></slot>
    <el-dialog :visible.sync="forbiddenFormVisible" :close-on-click-modal="false" title="Mute">
      <el-form ref="forbiddenForm" :model="forbiddenForm" label-width="120px">
        <el-input v-model="forbiddenForm.userId" type="hidden"></el-input>
        <el-form-item label="mute time" prop="reason">
          <el-select v-model="forbiddenForm.days">
            <el-option label="3 days" value="3" />
            <el-option label="5 days" value="3" />
            <el-option label="7 days" value="7" />
            <el-option label="15 days" value="15" />
            <el-option label="30 days" value="30" />
            <el-option label="permanent" value="-1" />
          </el-select>
        </el-form-item>
        <el-form-item label="mute reason" prop="reason">
          <el-select v-model="forbiddenForm.reason">
            <el-option value="advertise" />
            <el-option value="meaningless" />
            <el-option value="sex" />
            <el-option value="politics" />
            <el-option value="others" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="forbiddenFormVisible = false">Cancel</el-button>
        <el-button :loading="forbiddenLoading" type="primary" @click.native="forbidden"
          >mute
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      forbiddenForm: {
        userId: "",
        days: 0,
        reason: "",
      },
      forbiddenFormVisible: false,
      forbiddenLoading: false,
    };
  },
  methods: {
    showForbiddenDialog() {
      this.forbiddenForm = {
        userId: this.userId,
        days: 7,
        reason: "advertise",
      };
      this.forbiddenFormVisible = true;
    },
    async forbidden() {
      this.forbiddenLoading = true;
      try {
        await this.axios.form("base:/api/admin/user/forbidden", this.forbiddenForm);
        this.forbiddenForm = {};
        this.forbiddenFormVisible = false;
        this.$message.success("mute success");
      } catch (e) {
        this.$message.success("mute failed " + (e.message || e));
      } finally {
        this.forbiddenLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
